import { useContext } from 'react';

import EmergencyMessageContext from 'components/EmergencyMessage/emergencyMessageContext';

const useEmergencyMessage = () => useContext(EmergencyMessageContext);

export default useEmergencyMessage;
